// cityAddressReducer.js
const initialState = {
  cityAddressForm: JSON.parse(localStorage.getItem('cityAddressForm')) || {},
  cities: [],
  states: [],
  localeInfo: [],
  searchQuery: '',
  selectedState: '',
  loading: {
    searchCities: false,
    getStates: false,
    getLocale: false,
    searchZipcodes: false,
    default: false
  },
  error: null,

  // Legacy state for backward compatibility
  allCity: [],
  allStates: [],
  allZipCode: [],
};

const cityAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    // New action types
    case 'SEARCH_CITIES_SUCCESS':
      return { 
        ...state, 
        cities: action.payload, 
        allCity: action.payload, // backward compatibility
        error: null 
      };

    case 'GET_STATES_SUCCESS':
      return { 
        ...state, 
        states: action.payload, 
        allStates: action.payload, // backward compatibility
        error: null 
      };

    case 'GET_LOCALE_SUCCESS':
      return { 
        ...state, 
        localeInfo: action.payload, 
        allZipCode: action.payload, // backward compatibility
        error: null 
      };

    case 'SEARCH_ZIPCODES_SUCCESS':
      return {
        ...state,
        allZipCode: action.payload || [],
        error: null
      };

    case 'SEARCH_ZIPCODES_FAILURE':
      return {
        ...state,
        error: action.payload || 'Zip search failed.'
      };

    // Update search filters
    case 'SET_SEARCH_QUERY':
      return { ...state, searchQuery: action.payload };

    case 'SET_SELECTED_STATE':
      return { ...state, selectedState: action.payload };

    // Clear search results
    case 'CLEAR_CITIES':
      return { ...state, cities: [], allCity: [] };

    // Loading states
    case 'START_LOADING': {
      const key = action.service?.toLowerCase().replace('_', '') || 'default';
      return {
        ...state,
        loading: {
          ...state.loading,
          [key]: true,
        }
      };
    }

    case 'STOP_LOADING': {
      const key = action.service?.toLowerCase().replace('_', '') || 'default';
      return {
        ...state,
        loading: {
          ...state.loading,
          [key]: false,
        }
      };
    }

    // Error handling
    case 'SEARCH_CITIES_FAILURE':
    case 'GET_STATES_FAILURE':
    case 'GET_LOCALE_FAILURE':
    case 'GET_CITY_FAILURE':
    case 'GET_ZIPCODE_FAILURE':
      return { ...state, error: action.payload };

    // Clear errors
    case 'CLEAR_ERROR':
      return { ...state, error: null };

    // Legacy success types
    case 'GET_CITY_SUCCESS':
      return { ...state, allCity: action.payload, cities: action.payload, error: null };

    case 'GET_ZIPCODE_SUCCESS':
      return { ...state, allZipCode: action.payload, localeInfo: action.payload, error: null };

    default:
      return state;
  }
};

export default cityAddressReducer;
